import Logo from './Logo';
import { NavLink } from 'react-router-dom';

export default function Sidebar({ onLogout, role, open, onClose, dark, setDark }) {
  return (
    <>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <Logo size={30} sub="Repair System v26.05" />
          {role === 'technician' && (
            <div style={{ marginTop: 6, fontSize: 10, color: 'var(--primary)', fontWeight: 600 }}>🛠 TECHNICIAN</div>
          )}
          {role === 'viewer' && (
            <div style={{ marginTop: 6, fontSize: 10, color: 'var(--yellow)', fontWeight: 600 }}>👁 VIEW ONLY</div>
          )}
        </div>
        <nav className="sidebar-nav">
          <div className="nav-section">Main</div>
          <NavLink to="/" end className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">📊</span> Dashboard
          </NavLink>
          <NavLink to="/calendar" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">📅</span> Calendar
          </NavLink>
          <div className="nav-section">Operations</div>
          <NavLink to="/devices" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🔧</span> Devices
          </NavLink>
          <NavLink to="/field-visits" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🚐</span> زيارات ميدانية
          </NavLink>
          <NavLink to="/maintenance" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🛠</span> صيانة دورية
          </NavLink>
          <NavLink to="/tickets" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🎫</span> Tickets
          </NavLink>
          <NavLink to="/clients" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🏥</span> Clients
          </NavLink>
          <NavLink to="/part-needs" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🛒</span> Parts Needed
          </NavLink>
          <div className="nav-section">Sales</div>
          <NavLink to="/opportunities" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🎯</span> Opportunities
          </NavLink>
          <div className="nav-section">Finance</div>
          <NavLink to="/invoices" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">🧾</span> Invoices
          </NavLink>
          {role === 'technician' ? (
            <NavLink to="/engineers/me" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
              <span className="icon">💼</span> حسابي
            </NavLink>
          ) : (
            <NavLink to="/engineers" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
              <span className="icon">👷</span> المهندسين
            </NavLink>
          )}
          <NavLink to="/reports" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
            <span className="icon">📈</span> Reports
          </NavLink>
          {role === 'admin' && (
            <NavLink to="/settings" className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`} onClick={onClose}>
              <span className="icon">⚙️</span> Settings
            </NavLink>
          )}
        </nav>
        <div style={{ padding: '12px 8px', borderTop: '1px solid var(--border)' }}>
          <button className="nav-item" onClick={() => setDark && setDark(v => !v)} style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer' }}>
            <span className="icon">{dark ? '☀️' : '🌙'}</span> {dark ? 'Light Mode' : 'Dark Mode'}
          </button>
          <button className="nav-item" onClick={onLogout} style={{ width: '100%', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red)' }}>
            <span className="icon">🚪</span> Logout
          </button>
        </div>
      </aside>
    </>
  );
}
